import { useState } from 'react';
import useRootSelector from 'common/hooks/useRootSelector';

import useComponentDidUpdate from 'common/hooks/useComponentDidUpdate';
import { selectPrintHTMLLoading } from 'common/state/printHTML/selectors';

export const useCombinePrintLoading = (isLoading: boolean) => {
  const isPrintLoading: boolean = useRootSelector(selectPrintHTMLLoading);

  const [isPrinting, setIsPrinting] = useState(false);

  // start request
  useComponentDidUpdate(() => {
    if (isLoading) {
      setIsPrinting(true);
    }
  }, [isLoading]);

  // finish printing
  useComponentDidUpdate(() => {
    if (!isPrintLoading) {
      setIsPrinting(false);
    }
  }, [isPrintLoading]);

  return isPrinting;
};
